var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-anonymous-event-details',{attrs:{"startCollapsibleOpen":true,"id":_vm.$route.params.id,"module":_vm.module,"path-on-register":_vm.pathOnRegister}}),_c('br'),_c('b-floating-back-button')],1)}
var staticRenderFns = []

export { render, staticRenderFns }